import { render, staticRenderFns } from "./showSubmitInfo.vue?vue&type=template&id=6d2290dc"
import script from "./showSubmitInfo.vue?vue&type=script&lang=js"
export * from "./showSubmitInfo.vue?vue&type=script&lang=js"
import style0 from "./showSubmitInfo.vue?vue&type=style&index=0&id=6d2290dc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports